<template>
    <NavbarComp />
    <div id="main">
        <div id="sectionOne">
            <h3 id="txtTitle">Pilih Service Favorite</h3>
            <p id="txtCaption">
                Tingkatkan skill digitalmu dan belajar dengan para mentor terbaik dan berpengalaman
            </p>
            <div id="searchDiv">
                <img src="../assets/search.png">
                <input type="text" v-model="searchQuery" placeholder="Cari program yang kamu mau">
            </div>            
        </div>
        <div id="sectionTwo">
            <h4 id="kategori">Kategori</h4>
            <div id="isiKategori">
                <button id="btnKategori" value="dataScience" @click="active1 = !active1" :class="{btnActive1: active1 , btnNactive1: !active1}">Data Science</button>
                <button id="btnKategori" value="webDev" @click="active2 = !active2" :class="{btnActive2: active2 , btnNactive2: !active2}">Web Development</button>
            </div>
        </div>
        <div id="sectionThree">
            <div id="ktgrVertical">
                <div id="ktgrHorizontal">
                    <div id="event" v-for="service in resultQuery" :key="service.id">
                        <img id="imgEvent" src="../assets/img1.png">
                        <div id="rating">
                            <p id="jmlRating">5.0</p>
                            <img id="star" src="../assets/star.png">
                            <img id="star" src="../assets/star.png">
                            <img id="star" src="../assets/star.png">
                            <img id="star" src="../assets/star.png">
                            <img id="star" src="../assets/star.png">
                        </div>
                        <p id="titleEvent">{{ service.title }}</p>
                        <p id="hargaEvent">Rp.  1.150.000,00</p>
                        <div id="detailEvent">
                            <div id="session">
                                <div>
                                    <img src="../assets/icon_video.png">
                                </div>
                                <p id="txtSession">20 session</p>
                            </div>
                            <div id="peserta">
                                <div>
                                    <img src="../assets/icon_peserta.png">
                                </div>
                                <p id="txtPeserta">120 peserta</p>
                            </div>
                        </div>
                        <router-link :to="{name: ''}">
                            <button id="daftarEvent" value="daftarEvent">Daftar Sekarang</button>
                        </router-link>
                    </div>
                    <div id="event" v-for="service in resultQuery" :key="service.id">
                        <img id="imgEvent" src="../assets/img2.png">
                        <div id="rating">
                            <p id="jmlRating">5.0</p>
                            <img id="star" src="../assets/star.png">
                            <img id="star" src="../assets/star.png">
                            <img id="star" src="../assets/star.png">
                            <img id="star" src="../assets/star.png">
                            <img id="star" src="../assets/star.png">
                        </div>
                        <p id="titleEvent">{{ service.title }}</p>
                        <p id="hargaEvent">Rp.  1.150.000,00</p>
                        <div id="detailEvent">
                            <div id="session">
                                <div>
                                    <img src="../assets/icon_video.png">
                                </div>
                                <p id="txtSession">20 session</p>
                            </div>
                            <div id="peserta">
                                <div>
                                    <img src="../assets/icon_peserta.png">
                                </div>
                                <p id="txtPeserta">120 peserta</p>
                            </div>
                        </div>
                        <router-link :to="{name: ''}">
                            <button id="daftarEvent" value="daftarEvent">Daftar Sekarang</button>
                        </router-link>
                    </div>
                    <div id="event" v-for="service in resultQuery" :key="service.id">
                        <img id="imgEvent" src="../assets/img3.png">
                        <div id="rating">
                            <p id="jmlRating">5.0</p>
                            <img id="star" src="../assets/star.png">
                            <img id="star" src="../assets/star.png">
                            <img id="star" src="../assets/star.png">
                            <img id="star" src="../assets/star.png">
                            <img id="star" src="../assets/star.png">
                        </div>
                        <p id="titleEvent">{{ service.title }}</p>
                        <p id="hargaEvent">Rp.  1.150.000,00</p>
                        <div id="detailEvent">
                            <div id="session">
                                <div>
                                    <img src="../assets/icon_video.png">
                                </div>
                                <p id="txtSession">20 session</p>
                            </div>
                            <div id="peserta">
                                <div>
                                    <img src="../assets/icon_peserta.png">
                                </div>
                                <p id="txtPeserta">120 peserta</p>
                            </div>
                        </div>
                        <router-link :to="{name: ''}">
                            <button id="daftarEvent" value="daftarEvent">Daftar Sekarang</button>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section></section>
    <FooterComp />
</template>

<script>
    import NavbarComp from "../components/NavbarComp.vue";
    import FooterComp from "../components/FooterComp.vue";

    export default {
        name: 'ListService',
        components: {
            NavbarComp,
            FooterComp,
        },
        data() {
            return {
                searchQuery: null,
                service: [
                    { id: 1, title: "Machine Learning"},
                    { id: 2, title: "Deep Learning"},
                    { id: 3, title: "Data Analytics"},
                ],
                active1: false,
                active2: false,
            };
        },
        computed: {
            resultQuery() {
                if (this.searchQuery) {
                return this.service.filter(item => {
                    return this.searchQuery
                    .toLowerCase()
                    .split(" ")
                    .every(v => item.title.toLowerCase().includes(v));
                });
                } else {
                return this.service;
                }
            }
        }
    }
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');

    * {
        box-sizing: border-box;
    }

    body {
        margin: 0;
        background-color: #F5F5F5;
        font-family: 'Poppins', sans-serif;
    }

    #main {
        margin: 0 auto;
        width: 1250px;
        display: flex;
        flex-direction: column;
    }

    #sectionOne {
        padding-top: 100px;
        color: #023047;
    }

    #sectionOne h3 {
        margin-left: 400px;
        text-align: center;
        width: 458px;
        font-size: 32px;
        font-weight: 600;
    }

    #sectionOne p {
        margin-top: 30px;
        margin-left: 400px;
        text-align: center;
        width: 458px;
        font-size: 16px;
        font-weight: 400;
        opacity: 60%;
    }

    #searchDiv {
        border: 3px solid #E0E0E0;
        border-radius: 12px;
        margin-top: 80px;
        margin-left: 260px;
        width: 700px;
    }

    #searchDiv img {
        margin-left: 15px;
    }

    #searchDiv input {
        margin-left: 10px;
        border: none;
        border-radius: 12px;
        color: #9E9E9E;
        width: 645px;
    }

    #sectionTwo {
        flex: 5%;
        display: flex;
        flex-wrap: wrap;
        padding-top: 100px;
        padding-left: 100px;
    }

    #sectionTwo #kategori {
        flex: 60%;
    }

    #sectionTwo #isiKategori {
        flex: 40%;
    }

    #sectionTwo #btnKategori {
        margin-left: 16px;
        padding: 8px 32px;
        border-radius: 100px;
        font-size: 12px;
        cursor: pointer;
    }

    #sectionTwo #btnKategori:hover {
        background-color: #023047;
        color: white;
    }

    .btnActive1 , .btnActive2 , .btnActive3 {
        background-color: #023047;
        color: white;
    }

    .btnNactive1 , .btnNactive2 , .btnNactive3 {
        background-color: #CCD6DA;
        color: #023047;
    }

    #sectionThree {
        flex: 70%;
        padding-top: 100px;
    }

    #sectionThree #ktgrVertical {
        display: flex;
        flex-wrap: wrap;
    }

    #ktgrHorizontal {
        padding-left: 113px;
        margin-bottom: 62px;
        display: flex;
        flex-wrap: wrap;
    }

    #ktgrHorizontal #event {
        flex: 25%;
        margin-right: 50px;
        padding: 20px;
        border-radius: 36px;
        display: flex;
        flex-direction: column;
        background-color: white;
    }

    #event img {
        width: 254px;
        height: 172px;
    }

    #event #imgEvent {
        background-color: #FCAB97;
        border-radius: 16px;
    }

    #event #rating {
        display: flex;
        flex-direction: row;
        margin: 20px 0 0 5px;
        font-size: 16px;
        font-weight: 500;
    }

    #event #rating p {
        margin-right: 10px;
    }

    #event #star {
        width: 24px;
        height: 24px;
        margin-right: 3px;
        object-fit: cover;
    }

    #event #titleEvent {
        font-size: 18px;
        font-weight: 500;
        color: black;
    }

    #event #hargaEvent {
        color: #FF865D;
        font-size: 16px;
        font-weight: 400;
    }

    #event #detailEvent {
        display: flex;
        flex-direction: row;
    }

    #session {
        flex: 30%;
        display: flex;
        flex-direction: row;
    }

    #session img {
        width: 36px;
        height: 37px;
        object-fit: cover;
    }

    #peserta {
        flex: 45%;
        display: flex;
        flex-direction: row;
    }

    #peserta img {
        width: 40px;
        height: 40px;
        object-fit: cover;
    }

    #detailEvent p {
        padding-left: 10px;
        margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
    }

    #daftarEvent {
        margin-top: 20px;
        padding: 13px 70px;
        border-radius: 100px;
        background-color: #023047;
        color: white;
        font-size: 16px;
        font-weight: 400;
        cursor: pointer;
    }

    #daftarEvent:hover {
        background-color: white;
        color: #023047;
        outline-color: #023047;
    }

    section {
        height: 240px;
    }

    @media only screen and (max-width: 1100px) {

        #main {
            width: 885px;
        }

        #sectionOne h3 {
            margin-left: 80px;
            text-align: left;
        }

        #sectionOne p {
            margin-left: 80px;
            text-align: justify;
        }

        #searchDiv {
            margin-left: 80px;
            width: 60%;
        }
        
        #searchDiv input {
            width: 90%;
        }

        #sectionTwo {
            padding-left: 80px;
        }

        #sectionTwo #kategori {
            margin-right: -70%;
        }

        #ktgrHorizontal {
            padding-left: 80px;
        }

        #ktgrHorizontal #event {
            flex: 35%;
            margin-right: 0%;
        }

        #event #titleEvent {
            width: 250px;
        }

        #detailEvent p {
            width: 100px;
        }

        #session {
            flex: 0%;
        }
    }

    @media only screen and (max-width: 800px) {
        #main {
            max-width: 800px;
            margin-left: -5%;
        }

        #sectionOne {
            max-width: fit-content;
        }

        #sectionOne input {
            width: 85%;
        }

        #sectionTwo #kategori {
            flex: 40%;
        }

        #sectionTwo #btnKategori {
            margin-left: 10px;
            padding: 8px 25px;
        }

        #ktgrHorizontal #event {
            flex: 100%;
            margin-right: 0%;
        }

        #session {
            flex: 0%;
            margin-right: -15%;
        }
    }

    @media only screen and (max-width: 500px) {
        #main {
            width: 500px;
            margin-left: -12%;
        }

        #sectionOne p {
            width: 300px;
        }

        #sectionOne input {
            font-size: 14px;
            width: 82%;
        }

        #sectionTwo #kategori {
            font-size: 14px;
            margin-top: 10px;
            flex: 40%;
        }

        #sectionTwo #btnKategori {
            font-size: 11px;
            margin-top: 0%;
            margin-left: 5px;
            padding: 8px 15px;
        }

        #session {
            flex: 25%;
        }
    }

        @media only screen and (max-width: 400px) {
        #main {
            margin-left: -12%;
        }
        #sectionOne h3 {
            margin-left: 30%;
            text-align: left;
            width: 150px;
            font-size: 14px;
        }
        #sectionOne p {
            font-size: 12px;
            margin-top: 10px;
            margin-left: 30%;
            width: 200px;
        }
        #sectionOne input {
            font-size: 8px;
            margin-left: 5px;
            height: 20px;
            width: 80%;
        }
        #searchDiv {
            margin-top: 30px;
            margin-left: 30%;
            padding: 0;
            width: 95%;
        }
        #searchDiv img {
            width: 10px;
            margin-left: 5px;
        }
        #sectionTwo {
            padding-top: 50px;
        }
        #sectionTwo #kategori {
            font-size: 10px;
            margin-top: 8px;
            margin-left: -15px;
            flex: 35%;
        }
        #sectionTwo #btnKategori {
            font-size: 8px;
            margin-left: 3px;
            padding: 5px 10px;
        }
        #sectionThree {
            padding-top: 50px;
        }
        #ktgrHorizontal {
            padding-left: 50px;
        }
        #daftarEvent {
            padding: 13px 60px;
        }
        #session {
            flex: 20%;
        }
    }
</style>